import { Components } from '@mui/material';

import { NOTIFICATION_AUTO_HIDE_DURATION } from '../consts';

export const getMuiSnackbar = (): Components['MuiSnackbar'] => ({
  defaultProps: {
    autoHideDuration: NOTIFICATION_AUTO_HIDE_DURATION,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
  },
});
